import { Employee } from "../../types/Employee";
import { EmployeeActionList } from "../actions/employeeActions";
import { Action } from "../actions/types";

const initialValue: Array<Employee> = [];

export const employeeReducer = (
  state: Employee[] = initialValue,
  action: Action,
): Employee[] => {
  switch (action.type) {
    case EmployeeActionList.ADD_EMPLOYEE:
      return [...state, action.data];

    case EmployeeActionList.EDIT_EMPLOYEE: {
      const updated = [...state];
      const index = updated.findIndex((emp) => emp.id === action.data.id);
      if (index > -1) {
        updated[index] = { ...action.data };
      }
      return updated;
    }

    case EmployeeActionList.FETCH_EMPLOYEES:
      return action.data;

    case EmployeeActionList.FETCH_EMPLOYEEBYID:
      return action.data;

    case EmployeeActionList.DELETE_EMPLOYEE:
      return state.filter((emp) => emp.id !== action.data);

    default:
      return state;
  }
};
